module.exports = __webpack_public_path__ + "img/wxt3.83390244.jpg";